(() => {
  const LOCALE = (window.Shopify && Shopify.locale) || document.documentElement.lang || "en";
  const STRINGS = {
    en: { in: "In stock in", out: "Not in stock in" },
    nl: { in: "Op voorraad in", out: "Niet op voorraad in" },
    de: { in: "Auf Lager in", out: "Nicht auf Lager in" },
    da: { in: "På lager i", out: "Ikke på lager i" },
  };
  const t = (k) => (STRINGS[(LOCALE.split("-")[0] || "en")] || STRINGS.en)[k];

  function parseLocations(el) {
    try { return JSON.parse(el.getAttribute("data-locations")) || []; }
    catch { return []; }
  }

  function draw(el, items) {
    el.innerHTML = "";
    items.forEach(({ name, totalAvailable }) => {
      const ok = Number(totalAvailable || 0) > 0;
      const row = document.createElement("div");
      row.className = `store-availability-line ${ok ? "is-available" : "is-unavailable"}`;
      row.innerHTML = `
        <span class="dot" aria-hidden="true"></span>
        <span class="store-availability-text">${ok ? t("in") : t("out")} ${name}</span>
      `;
      el.appendChild(row);
    });
  }

  async function refresh(el) {
    const productId = el.getAttribute("data-product-id");
    const locs = parseLocations(el);
    if (!productId || !locs.length) return;

    el.classList.add("is-loading");
    try {
      const ids = locs.map(l => l.id).join(",");
      const url = `${Shopify.routes.root.replace(/\/$/, "")}/apps/pos-availability?productId=${encodeURIComponent(productId)}&loc=${encodeURIComponent(ids)}`;
      const res = await fetch(url, { credentials: "same-origin" });
      const json = await res.json();
      const byId = Object.fromEntries((json.locations || []).map(l => [String(l.id).replace(/\D/g, ""), l]));
      const items = locs.map(l => {
        const key = String(l.id).replace(/\D/g, "");
        const hit = byId[key];
        return { name: l.name, totalAvailable: Number(hit?.totalAvailable || 0) };
      });
      draw(el, items);
    } catch {
      draw(el, parseLocations(el).map(l => ({ name: l.name, totalAvailable: 0 })));
    } finally {
      el.classList.remove("is-loading");
    }
  }

  function init() {
    document.querySelectorAll(".store-location-availability").forEach(el => {
      if (el.dataset.bound) return; el.dataset.bound = "1";
      refresh(el);
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();